import React, { useState, useEffect } from "react";
import {
  Card,
  Table,
  Button,
  Form,
  Modal,
  Spinner,
  Alert,
} from "react-bootstrap";

import api, { getApiErrorMessage, resolvePendampingDocUrl } from "../../services/api";
import "./Dashboard.css";

const CalonPendamping = () => {
  const [pendampingList, setPendampingList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedPendamping, setSelectedPendamping] = useState(null);
  const [provinsiList, setProvinsiList] = useState([]);
  const [selectedProvinsi, setSelectedProvinsi] = useState("");
  const [showTerimaModal, setShowTerimaModal] = useState(false);
  const [terimaTarget, setTerimaTarget] = useState(null);
  const [terimaLoading, setTerimaLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [resetPasswordTarget, setResetPasswordTarget] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);
  const [resetPasswordError, setResetPasswordError] = useState(null);
  const [showTolakModal, setShowTolakModal] = useState(false);
  const [tolakTarget, setTolakTarget] = useState(null);
  const [tolakCatatan, setTolakCatatan] = useState("");
  const [tolakLoading, setTolakLoading] = useState(false);
  const [showHapusModal, setShowHapusModal] = useState(false);
  const [hapusTarget, setHapusTarget] = useState(null);
  const [hapusLoading, setHapusLoading] = useState(false);

  useEffect(() => {
    fetchCalonPendamping();
    fetchProvinsi();
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = pendampingList.filter((item) => {
      const matchSearch =
        !term ||
        item.nama?.toLowerCase().includes(term) ||
        item.email?.toLowerCase().includes(term) ||
        item.no_hp?.toLowerCase().includes(term) ||
        item.nik?.toLowerCase().includes(term);
      const matchProvinsi =
        !selectedProvinsi ||
        (item.provinsi_nama || item.provinsi) === selectedProvinsi;
      return matchSearch && matchProvinsi;
    });
    setFilteredList(filtered);
  }, [searchTerm, selectedProvinsi, pendampingList]);

  const fetchProvinsi = async () => {
    try {
      const response = await api.get("/reference/provinsi");
      if (response.data.success) {
        setProvinsiList(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching provinsi:", err);
    }
  };

  const fetchCalonPendamping = async (silent = false) => {
    try {
      if (!silent) setLoading(true);
      const response = await api.get("/pendamping/calon-peserta");
      if (response.data.success) {
        setPendampingList(response.data.data);
        setFilteredList(response.data.data);
      } else {
        setError("Tidak dapat memuat data calon pendamping.");
      }
      if (!silent) setLoading(false);
    } catch (error) {
      console.error("Error fetching calon pendamping:", error);
      setError("Gagal memuat data calon pendamping. Silakan coba lagi.");
      if (!silent) setLoading(false);
    }
  };

  const handleShowModal = (pendamping) => {
    setSelectedPendamping(pendamping);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPendamping(null);
  };

  const handleTerima = (pendamping) => {
    setTerimaTarget(pendamping);
    setShowTerimaModal(true);
  };

  const handleKonfirmasiTerima = async () => {
    if (!terimaTarget) return;
    setTerimaLoading(true);
    try {
      const response = await api.post("/pendamping/terima", {
        pendamping: terimaTarget,
      });
      if (response.data.success) {
        setShowTerimaModal(false);
        const namaTerima = terimaTarget.nama;
        setTerimaTarget(null);
        await fetchCalonPendamping(true);
        setSuccessMessage(
          `${namaTerima} berhasil diterima sebagai Peserta Pelatihan.`,
        );
      } else {
        setError(response.data.message || "Gagal menerima calon pendamping.");
        setShowTerimaModal(false);
      }
    } catch (err) {
      setError(
        getApiErrorMessage(err, "Gagal menerima calon pendamping. Silakan coba lagi."),
      );
      setShowTerimaModal(false);
    } finally {
      setTerimaLoading(false);
    }
  };

  const handleResetPassword = (pendamping) => {
    setResetPasswordTarget(pendamping);
    setNewPassword("");
    setConfirmPassword("");
    setResetPasswordError(null);
    setShowResetPasswordModal(true);
  };

  const handleKonfirmasiResetPassword = async () => {
    if (!resetPasswordTarget) return;
    if (!newPassword) {
      setResetPasswordError("Password baru tidak boleh kosong.");
      return;
    }
    if (newPassword.length < 6) {
      setResetPasswordError("Password minimal 6 karakter.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setResetPasswordError("Konfirmasi password tidak cocok.");
      return;
    }
    setResetPasswordLoading(true);
    setResetPasswordError(null);
    try {
      const response = await api.post(
        "/pendamping/reset-password-local",
        {
          id_pendamping: resetPasswordTarget.id_pendamping,
          new_password: newPassword,
        },
      );
      if (response.data.success) {
        setShowResetPasswordModal(false);
        setSuccessMessage(
          `Password untuk ${resetPasswordTarget.nama} berhasil direset.`,
        );
      } else {
        setResetPasswordError(
          response.data.message || "Gagal mereset password.",
        );
      }
    } catch (err) {
      setResetPasswordError(
        err.response?.data?.message || "Gagal menghubungi server.",
      );
    } finally {
      setResetPasswordLoading(false);
    }
  };

  const handleDitolak = (pendamping) => {
    setTolakTarget(pendamping);
    setTolakCatatan("");
    setShowTolakModal(true);
  };

  const handleKonfirmasiTolak = async () => {
    if (!tolakTarget) return;
    setTolakLoading(true);
    try {
      const response = await api.post("/pendamping/tolak", {
        id_pendamping: tolakTarget.id_pendamping,
        catatan: tolakCatatan,
      });
      if (response.data.success) {
        setShowTolakModal(false);
        const namaTolak = tolakTarget.nama;
        setTolakTarget(null);
        await fetchCalonPendamping(true);
        setSuccessMessage(`${namaTolak} berhasil ditolak.`);
      } else {
        setError(response.data.message || "Gagal menolak calon pendamping.");
        setShowTolakModal(false);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Gagal menghubungi server.");
      setShowTolakModal(false);
    } finally {
      setTolakLoading(false);
    }
  };

  const handleHapus = (pendamping) => {
    setHapusTarget(pendamping);
    setShowHapusModal(true);
  };

  const handleKonfirmasiHapus = async () => {
    if (!hapusTarget) return;
    setHapusLoading(true);
    try {
      const response = await api.delete(
        `/pendamping/${hapusTarget.id_pendamping}`,
      );
      if (response.data.success) {
        const deletedId = hapusTarget.id_pendamping;
        const namaHapus = hapusTarget.nama;
        setShowHapusModal(false);
        setHapusTarget(null);
        // Hilangkan segera dari UI agar tidak menunggu refresh
        setPendampingList((prev) =>
          prev.filter((p) => p.id_pendamping !== deletedId),
        );
        setFilteredList((prev) =>
          prev.filter((p) => p.id_pendamping !== deletedId),
        );
        await fetchCalonPendamping(true);
        setSuccessMessage(`Data ${namaHapus} berhasil dihapus.`);
      } else {
        setError(response.data.message || "Gagal menghapus data.");
        setShowHapusModal(false);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Gagal menghubungi server.");
      setShowHapusModal(false);
    } finally {
      setHapusLoading(false);
    }
  };

  const getFileUrl = (folder, filename, sumber, fullUrl) =>
    resolvePendampingDocUrl(folder, filename, fullUrl);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div>
      <div
        className="page-header-banner"
        style={{
          background:
            "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
        }}
      >
        <div className="page-header-content">
          <div className="page-header-left">
            <div className="page-header-icon">
              <i className="fas fa-user-graduate"></i>
            </div>
            <div>
              <h1 className="page-header-title">Daftar Calon Peserta</h1>
              <p className="page-header-subtitle">
                Kelola dan monitoring calon pendamping
              </p>
            </div>
          </div>
        </div>
      </div>

      {successMessage && (
        <Alert
          variant="success"
          dismissible
          onClose={() => setSuccessMessage(null)}
        >
          {successMessage}
        </Alert>
      )}

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card>
        <Card.Body>
          <div className="row mb-3 align-items-center">
            <div className="col-md-5 mb-2 mb-md-0">
              <Form.Control
                type="text"
                placeholder="Cari nama, email, no HP atau NIK..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-2 mb-md-0">
              <Form.Select
                value={selectedProvinsi}
                onChange={(e) => setSelectedProvinsi(e.target.value)}
              >
                <option value="">-- Semua Provinsi --</option>
                {provinsiList.map((p) => (
                  <option key={p.kodeprovinsi} value={p.namaprovinsi}>
                    {p.namaprovinsi}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-3 text-end">
              <Button variant="primary" onClick={fetchCalonPendamping}>
                <i className="fas fa-sync-alt me-2" /> Refresh
              </Button>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama</th>
                    <th>Referral</th>
                    <th>No HP</th>
                    <th>Email</th>
                    <th>Provinsi</th>
                    <th>Kabupaten</th>
                    <th>Tgl Daftar</th>
                    <th>KTP</th>
                    <th>Ijazah</th>
                    <th>Foto Diri</th>
                    <th>Sumber</th>
                    <th>Aksi</th>
                    <th>Reset Password</th>
                    <th>Hapus</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.length === 0 ? (
                    <tr>
                      <td colSpan="15" className="text-center">
                        Data calon pendamping tidak ditemukan
                      </td>
                    </tr>
                  ) : (
                    filteredList.map((item, index) => (
                      <tr key={item.id_pendamping || index}>
                        <td>{index + 1}</td>
                        <td>
                          {item.nama || "-"}
                          {item.kode_referral && (
                            <div className="small text-muted">
                              Kode Referral: <strong>{item.kode_referral}</strong>
                            </div>
                          )}
                        </td>
                        <td>
                          {item.referral ? (
                            <>
                              <div>{item.referral}</div>
                              {item.nama_referral && (
                                <div className="small text-muted">
                                  {item.nama_referral}
                                </div>
                              )}
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{item.no_hp || "-"}</td>
                        <td>{item.email || "-"}</td>
                        <td>{item.provinsi_nama || item.provinsi || "-"}</td>
                        <td>{item.kabupaten_nama || item.kabupaten || "-"}</td>
                        <td>{formatDate(item.created_on)}</td>
                        <td>
                          {item.fotoktp ? (
                            <a
                              href={getFileUrl(
                                "ktp",
                                item.fotoktp,
                                item.sumber,
                                item.fotoktp_url,
                              )}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary"
                            >
                              KTP
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {item.fotoijazah ? (
                            <a
                              href={getFileUrl(
                                "ijazah",
                                item.fotoijazah,
                                item.sumber,
                                item.fotoijazah_url,
                              )}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary"
                            >
                              Ijazah
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {item.filefoto ? (
                            <a
                              href={getFileUrl(
                                "foto",
                                item.filefoto,
                                item.sumber,
                                item.filefoto_url,
                              )}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary"
                            >
                              Foto
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          <span
                            className={`badge ${
                              item.sumber === "WEB SIHALAL"
                                ? "bg-success"
                                : "bg-primary"
                            }`}
                          >
                            {item.sumber || "-"}
                          </span>
                        </td>
                        <td>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleShowModal(item)}
                            className="me-2"
                          >
                            Detail
                          </Button>
                          <Button
                            variant="success"
                            size="sm"
                            className="me-1"
                            onClick={() => handleTerima(item)}
                          >
                            Terima
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDitolak(item)}
                          >
                            Ditolak
                          </Button>
                        </td>
                        <td>
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => handleResetPassword(item)}
                          >
                            Reset Password
                          </Button>
                        </td>
                        <td>
                          {item.sumber === "WEB LOCAL" ? (
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleHapus(item)}
                              title="Hapus data calon"
                            >
                              <i className="fas fa-trash" />
                            </Button>
                          ) : (
                            <span
                              className="text-muted"
                              title="Data SIHALAL tidak dapat dihapus dari sini"
                            >
                              -
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Detail Calon Pendamping</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPendamping ? (
            <div>
              <p>
                <strong>Nama:</strong> {selectedPendamping.nama}
              </p>
              <p>
                <strong>No HP:</strong> {selectedPendamping.no_hp}
              </p>
              <p>
                <strong>Email:</strong> {selectedPendamping.email}
              </p>
              <p>
                <strong>NIK:</strong> {selectedPendamping.nik}
              </p>
              <p>
                <strong>Alamat:</strong> {selectedPendamping.alamat || "-"}
              </p>
              <p>
                <strong>Provinsi / Kabupaten:</strong>{" "}
                {selectedPendamping.provinsi_nama ||
                  selectedPendamping.provinsi ||
                  "-"}{" "}
                /{" "}
                {selectedPendamping.kabupaten_nama ||
                  selectedPendamping.kabupaten ||
                  "-"}
              </p>
              <p>
                <strong>Tanggal Lahir:</strong>{" "}
                {selectedPendamping.tgl_lahir
                  ? formatDate(selectedPendamping.tgl_lahir)
                  : "-"}
              </p>
              <p>
                <strong>Status:</strong> {selectedPendamping.status || "-"}
              </p>
              <p>
                <strong>Sumber Data:</strong>{" "}
                <span
                  className={`badge ${
                    selectedPendamping.sumber === "WEB SIHALAL"
                      ? "bg-success"
                      : "bg-primary"
                  }`}
                >
                  {selectedPendamping.sumber || "-"}
                </span>
              </p>
              <p>
                <strong>Kode Referral:</strong>{" "}
                {selectedPendamping.kode_referral || "-"}
              </p>
              <p>
                <strong>Referral (Pengajak):</strong>{" "}
                {selectedPendamping.referral
                  ? `${selectedPendamping.referral}${
                      selectedPendamping.nama_referral
                        ? ` - ${selectedPendamping.nama_referral}`
                        : ""
                    }`
                  : "-"}
              </p>
              <p>
                <strong>Foto Diri:</strong>{" "}
                {selectedPendamping.filefoto ? (
                  <a
                    href={getFileUrl(
                      "foto",
                      selectedPendamping.filefoto,
                      selectedPendamping.sumber,
                      selectedPendamping.filefoto_url,
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Lihat Foto
                  </a>
                ) : (
                  "-"
                )}
              </p>
              <p>
                <strong>File KTP:</strong>{" "}
                {selectedPendamping.fotoktp ? (
                  <a
                    href={getFileUrl(
                      "ktp",
                      selectedPendamping.fotoktp,
                      selectedPendamping.sumber,
                      selectedPendamping.fotoktp_url,
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download KTP
                  </a>
                ) : (
                  "-"
                )}
              </p>
              <p>
                <strong>File Ijazah:</strong>{" "}
                {selectedPendamping.fotoijazah ? (
                  <a
                    href={getFileUrl(
                      "ijazah",
                      selectedPendamping.fotoijazah,
                      selectedPendamping.sumber,
                      selectedPendamping.fotoijazah_url,
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download Ijazah
                  </a>
                ) : (
                  "-"
                )}
              </p>
            </div>
          ) : (
            <p>Tidak ada data</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showTolakModal}
        onHide={() => !tolakLoading && setShowTolakModal(false)}
        centered
      >
        <Modal.Header closeButton={!tolakLoading}>
          <Modal.Title>Tolak Calon Pendamping</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Anda akan menolak: <strong>{tolakTarget?.nama}</strong>
          </p>
          <Form.Group>
            <Form.Label>Alasan Penolakan</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Masukkan alasan penolakan (opsional)"
              value={tolakCatatan}
              onChange={(e) => setTolakCatatan(e.target.value)}
              disabled={tolakLoading}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowTolakModal(false)}
            disabled={tolakLoading}
          >
            Batal
          </Button>
          <Button
            variant="danger"
            onClick={handleKonfirmasiTolak}
            disabled={tolakLoading}
          >
            {tolakLoading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Memproses...
              </>
            ) : (
              "Ya, Tolak"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showHapusModal}
        onHide={() => !hapusLoading && setShowHapusModal(false)}
        centered
      >
        <Modal.Header closeButton={!hapusLoading}>
          <Modal.Title>Konfirmasi Hapus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Apakah Anda yakin ingin menghapus data calon{" "}
          <strong>{hapusTarget?.nama}</strong>? Tindakan ini akan menghapus data
          pendaftaran beserta akun login terkait dan tidak dapat dibatalkan.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowHapusModal(false)}
            disabled={hapusLoading}
          >
            Batal
          </Button>
          <Button
            variant="danger"
            onClick={handleKonfirmasiHapus}
            disabled={hapusLoading}
          >
            {hapusLoading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Menghapus...
              </>
            ) : (
              "Ya, Hapus"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showResetPasswordModal}
        onHide={() => !resetPasswordLoading && setShowResetPasswordModal(false)}
        centered
      >
        <Modal.Header closeButton={!resetPasswordLoading}>
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Reset password untuk: <strong>{resetPasswordTarget?.nama}</strong>
          </p>
          {resetPasswordError && (
            <Alert variant="danger" className="py-2">
              {resetPasswordError}
            </Alert>
          )}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Password Baru</Form.Label>
              <Form.Control
                type="password"
                placeholder="Masukkan password baru (min. 6 karakter)"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={resetPasswordLoading}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Konfirmasi Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Ulangi password baru"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={resetPasswordLoading}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowResetPasswordModal(false)}
            disabled={resetPasswordLoading}
          >
            Batal
          </Button>
          <Button
            variant="warning"
            onClick={handleKonfirmasiResetPassword}
            disabled={resetPasswordLoading}
          >
            {resetPasswordLoading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Memproses...
              </>
            ) : (
              "Reset Password"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showTerimaModal}
        onHide={() => !terimaLoading && setShowTerimaModal(false)}
        centered
      >
        <Modal.Header closeButton={!terimaLoading}>
          <Modal.Title>Konfirmasi Penerimaan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Apakah Anda yakin ingin menerima <strong>{terimaTarget?.nama}</strong>{" "}
          sebagai Peserta Pelatihan?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowTerimaModal(false)}
            disabled={terimaLoading}
          >
            Tidak
          </Button>
          <Button
            variant="success"
            onClick={handleKonfirmasiTerima}
            disabled={terimaLoading}
          >
            {terimaLoading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Memproses...
              </>
            ) : (
              "Ya, Terima"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CalonPendamping;
